import { Component, OnInit } from "@angular/core";
import { Chart } from "angular-highcharts";
import { EventService } from "src/app/services/event.service";
import { chartConfigs } from "../epack/epack.component";

export interface TestPackData {
  pack_id: string;
  bms_id: string;
  product_id: string;
  variant_id: string;
  sop_flash: string;
  test_type: string;
}

@Component({
  selector: "app-bmsipqc",
  templateUrl: "./bmsipqc.component.html",
  styleUrls: ["./bmsipqc.component.css"],
})
export class BmsipqcComponent implements OnInit {
  constructor(private eventService: EventService) {}

  monthlyTestYears: number[] = [2024, 2025];
  dailyTestMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  currentDate = new Date();
  selectedYear: number = this.currentDate.getFullYear();
  selectedMonth: number = this.currentDate.getMonth() + 1;
  dashboardTableCols: string[] = [
    "S.No",
    "Test ID",
    "Battery ID",
    "BMS ID",
    "Date",
    // "Test Status",
    "Test Result",
    "Analytics",
    "Download",
  ];

  defaultChartOptions: Highcharts.Options = {
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
    },
    yAxis: {
      title: {
        text: "",
      },
    },
  };
  graphHeight: number = 300;
  yearlyTestsChart: Chart;
  monthlyTestsChart: Chart;
  yearlyTestsChartData: {
    [year: number]: number[];
  };
  monthlyTestsChartData: {
    passing: { [month: number]: number[] };
    failing: { [month: number]: number[] };
  };

  ngOnInit(): void {
    this.getDashboardYearlyTestsData();
  }

  getDashboardYearlyTestsData() {
    this.eventService.getIpqcDashboardYearlyTestsData().subscribe({
      next: (response: {
        success: boolean;
        data: { [year: number]: number[] };
      }) => {
        if (response.success) {
          this.yearlyTestsChartData = response.data;
          this.plotYearlyTestsGraph(
            this.yearlyTestsChartData[this.selectedYear]
          );
          this.getDashboardMonthlyTestsData(this.selectedYear);
        }
      },
    });
  }

  getDashboardMonthlyTestsData(year: number) {
    this.eventService.getIpqcDashboardMonthlyTestsData(year).subscribe({
      next: (response: {
        success: boolean;
        data: {
          passing: { [month: number]: number[] };
          failing: { [month: number]: number[] };
        };
      }) => {
        if (response.success) {
          this.monthlyTestsChartData = {
            failing: response.data.failing,
            passing: response.data.passing,
          };

          this.plotMonthlyTestsGraph(
            this.monthlyTestsChartData.passing[this.selectedMonth],
            this.monthlyTestsChartData.failing[this.selectedMonth]
          );
        }
      },
    });
  }

  onYearchange() {
    // reset months selection when year changes
    this.selectedMonth = this.currentDate.getMonth() + 1;

    const currentYearData =
      this.yearlyTestsChartData[this.selectedYear] ?? Array(12).fill(0);

    this.plotYearlyTestsGraph(currentYearData);
    this.getDashboardMonthlyTestsData(this.selectedYear);
  }

  onMonthChange() {
    this.plotMonthlyTestsGraph(
      this.monthlyTestsChartData.passing[this.selectedMonth],
      this.monthlyTestsChartData.failing[this.selectedMonth]
    );
  }

  plotYearlyTestsGraph(graphData: number[]) {
    this.yearlyTestsChart = new Chart({
      ...this.defaultChartOptions,
      legend: {
        enabled: false,
      },
      chart: {
        height: this.graphHeight,
      },
      xAxis: { categories: chartConfigs.axisData.monthlyTests },
      tooltip: {
        headerFormat: '<h1 style=""><b>{point.key}:</b> {point.y}</h1></br>',
        pointFormat: "",
        footerFormat: "",
      },
      series: [
        {
          type: "column",
          data: graphData,
          color: chartConfigs.colors.total,
        },
      ],
    });
  }

  plotMonthlyTestsGraph(passingData: number[], failingData: number[]) {
    const daysInMonth = new Date(
      this.selectedYear,
      this.selectedMonth,
      0
    ).getDate();
    const categories = [];
    const testMonth = this.dailyTestMonths[this.selectedMonth - 1];

    for (let i = 0; i < daysInMonth; i++) {
      categories[i] = i + 1;
    }

    this.monthlyTestsChart = new Chart({
      ...this.defaultChartOptions,
      chart: {
        height: this.graphHeight,
      },
      xAxis: {
        categories: categories,
      },
      tooltip: {
        headerFormat: `<h2><b>${testMonth} {point.key} </b></h2></br>`,
        shared: true,
      },
      series: [
        {
          type: "spline",
          name: "Failed Tests",
          color: chartConfigs.colors.pending,
          data: failingData,
        },
        {
          type: "spline",
          name: "Passed Tests",
          color: chartConfigs.colors.completed,
          data: passingData,
        },
      ],
    });
  }
}
